<div class="row">
	<div class="col-sm-12">
		<app-activity-list-filters
			#listfilters
			[searchparams]="advancedSearch"
			[objectiveid]="objectiveid">
		</app-activity-list-filters>
	</div>
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="card-datatable"
			[options]="false">

			<a
				class="float-right btn btn-sm btn-primary"
				routerLink="/project/objective/{{objectiveid}}/activity/new">
				<i
					container="body"
					ngbTooltip="{{'labels.create' | translate}}"
					class="feather icon-plus"></i>
			</a>

			<div class="table-responsive">

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="rows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="true"
					[externalSorting]="true"
					[loadingIndicator]="loading"
					[count]="page.totalElements"
					[offset]="page.pageNumber"
					[limit]="page.size"
					[rowClass]="rowClass"
					(page)="onPageChange($event)"
					(sort)="onSortChange($event)"
					(activate)="onActivate($event)"
					[messages]="{
          emptyMessage: 'labels.empty-activities' | translate,
          totalMessage: 'labels.total' | translate
		}">
					<!-- id -->
					<ngx-datatable-column
						prop="id"
						[flexGrow]="0.5"
						[name]="'labels.id' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<a
								routerLink="/project/objective/activity/view/{{row.id}}"
								class="link"
								ngbTooltip="{{'labels.details' | translate}}">
								{{value}}
							</a>
						</ng-template>
					</ngx-datatable-column>
					<!-- name -->
					<ngx-datatable-column
						prop="name"
						[flexGrow]="2"
						[name]="'labels.name' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<a
								routerLink="/project/objective/activity/view/{{row.id}}"
								class="link"
								ngbTooltip="{{'labels.details' | translate}}">
								{{value}}
							</a>
						</ng-template>
					</ngx-datatable-column>
					<!-- startdate -->
					<ngx-datatable-column
						prop="startdate"
						[flexGrow]="1.5"
						[name]="'labels.startdate' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							ngx-datatable-cell-template>
							{{value | date: 'dd/MM/yyyy' }}
						</ng-template>
					</ngx-datatable-column>
					<!-- stopdate -->
					<ngx-datatable-column
						prop="stopdate"
						[flexGrow]="1.5"
						[name]="'labels.stopdate' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							ngx-datatable-cell-template>
							{{value | date: 'dd/MM/yyyy' }}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">

								<a
									routerLink="/project/objective/{{objectiveid}}/activity/edit/{{row.id}}"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.edit' | translate}}"
										class="feather icon-edit"></i>
								</a>
								<a
									(click)="delete(row, $event)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.delete' | translate}}"
										class="feather icon-trash"></i>
								</a>

							</div>
						</ng-template>
					</ngx-datatable-column>
				</ngx-datatable>
			</div>
		</app-card>
	</div>
</div>
